import type { ReportData } from '@ipfabric/utils';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { ApiTableCommandFactory } from '../ApiTableModel';

interface UpdateTableReportsCommand {
  data: ReportData[];
}

export const updateTableReports: ApiTableCommandFactory<
  UpdateTableReportsCommand
> = (cmdContext) => async (command) => {
  const { reports } = cmdContext.getState();

  const updatedReports = pipe(
    reports,
    record.map((report) => {
      const foundUpdate = command.data.find((d) => d.id === report.id);

      return foundUpdate ?? report;
    }),
  );

  cmdContext.updateState((draft) => {
    draft.reports = updatedReports;
  });
};
